export const getListDocumentosErro = (state) =>
  state.administracao["painel-integracao"]["documentos-erro"];
